import React from 'react';
import BasicDialogV2 from './modules/dialogs/BasicDialogV2';
import WarningDialog from './modules/dialogs/WarningDialog';
import axios from 'axios';
import http from './modules/api';
import { Link } from 'react-router-dom';
import '../css/style.css';

const toDialogContent = (message) =>
  String(message ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\r?\n/g, "<br/>");

export class PwdSearch extends React.Component {
	
	state = {
			user_id: '',
			tel_no: '',
			dialogType: '',
			dialogMessage: ''
	}
	
	showWarningDialog = (message) => {
		this.setState({dialogType: 'warning', dialogMessage: String(message ?? '')});
	};

	showBasicDialog = (message) => {
		this.setState({dialogType: 'basic', dialogMessage: String(message ?? '')});
	};

	closeDialog = () => {
		this.setState({dialogType: '', dialogMessage: ''});
	};

	renderDialog = () => {
		if (!this.state.dialogType) return null;
		const Dialog = this.state.dialogType === 'warning' ? WarningDialog : BasicDialogV2;
		return (
			<Dialog
				content={toDialogContent(this.state.dialogMessage)}
				button_list={[{title: '확인', event_method: this.closeDialog}]}
				popup_close={this.closeDialog}
			/>
		);
	};

	handleText = (e, key) => {
	    // computed property
		this.setState({[key]: e.target.value});
	}

	onClickPwdSearchButton = () => {
		
		const sendForm = {...this.state};
		
		//1. Validation Check
		if (sendForm.user_id == null || sendForm.user_id == "") {
			this.showWarningDialog("아이디를 입력해 주세요.");
			return false;
		}
		if (sendForm.tel_no == null || sendForm.tel_no == "") {
			this.showWarningDialog("연락처를 입력해 주세요.\n(비밀번호 분실시 카카오 알림톡을 수신 가능한 연락처)");
			return false;
		}
		
		axios.get("/rest/common/pwd/search", {params:sendForm})
			 .then(
					 resultData => {
						 var data = resultData.data;
						 this.showBasicDialog(data.data);
					 });
	}
	
	render() {
		
		return (
			<>
			{/* <div id='non-page-wrapper'>
			<div className="login-container"> */}
					{/* <div className="middle-box text-center loginscreen animated fadeInDown"> */}
					<>
					<div className="mobile_margin_top_0 middle-box middle-box-mobile text-center" style={{display:"flex", maxWidth:"100%", paddingTop:0, height:"100vh"}}>
						<section className="login-section" style={{display: "flex", width:"100%", height:"auto", margin:"auto 0", background:"white"}}>
							<div className="container">
								<div className="form-inline">
									<div  style={{display: "flex", width:"100%", textAlign:"left", color:"#333333", fontWeight:"bold", fontSize:"25px", marginBottom:"10vh", justifyContent:"space-between"}}>
										<div>
										비밀번호가 기억나지 않으세요?<br/>걱정 마세요.
										</div>
										<div style={{display: "flex", minWidth: "59px", marginLeft:"10px", paddingTop: "5px"}}>
											<Link to={`/common/registUser`} style={{alignSelf:"flex-start", fontSize:"17px", color: "#10CFC9"}}>회원가입</Link>
										</div>
									</div>
									<label style={{color:"#333333", fontWeight:"bold", marginBottom:"27px", justifyContent: "left"}}>
										아이디
									</label>
									<div style={{display: "flex", width:"100%", height:"124px"}}>
										<input className="form-control" style={{width:"100%", background:"#ffffff"}}  type="text" placeholder="정확한 아이디를 기입해 주세요." id="user_id" value={this.state.user_id} onChange={(e) => this.handleText(e, 'user_id')} />
									</div>
									<label style={{color:"#333333", fontWeight:"bold", marginBottom:"27px", justifyContent: "left"}}>
										연락처
									</label>
									<div style={{display: "flex", width:"100%", height:"124px"}}>
										<input className="form-control" style={{width:"100%", background:"#ffffff"}}  type="text" placeholder="정확한 연락처를 기입해 주세요." id="tel_no" value={this.state.tel_no} onChange={(e) => this.handleText(e, 'tel_no')} />
									</div>
									<div className="mobile-flex-wrap-align-right" style={{display: "flex", width:"100%", justifyContent:"space-between"}}>
										<div className="find_btn_box m-t-xs mobile_margin_bottom_30px" style={{width:"auto", display:"flex", flexWrap: "nowrap", margin:"auto 0", alignContent:"middle", fontSize:"15px", lineHeight:"20px"}}>
											{/* <Link className="btn find_btn" to={`/common/registUser`}>회원가입</Link> */}
											<Link to={`/login`} style={{color:"#10CFC9"}}>로그인하기&nbsp;·&nbsp;</Link>
											<Link to={`/common/id/search`} style={{color:"#10CFC9"}}>아이디찾기</Link>
										</div>
										<div className="mobile_margin_bottom_30px mobile_margin_left_20px" style={{width:"200px", height:"60px", margon:"auto 0", fontSize:"15px"}}>
											<button className="btn-white main_login" style={{height:"100%", color:"white", background:"#10CFC9", borderRadius: "13px", lineHeight:"20px" , border:0}} onClick={this.onClickPwdSearchButton}>임시 비밀번호 발급</button>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
					{this.renderDialog()}
					</>
				{/* </div>
			</div> */}
			</>
		);
	}
	
}
